__webpack_require__.p = "/1yd9uqc-je-refactor/referrals/";